/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Opacity_AriaInputs */

const en_video_export_opacity_aria = /** @type {(inputs: Video_Export_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Opacity`)
};

const fr_video_export_opacity_aria = /** @type {(inputs: Video_Export_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacite du texte`)
};

const de_video_export_opacity_aria = /** @type {(inputs: Video_Export_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textdeckkraft`)
};

const it_video_export_opacity_aria = /** @type {(inputs: Video_Export_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacità del testo`)
};

const ru_video_export_opacity_aria = /** @type {(inputs: Video_Export_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прозрачность текста`)
};

const es_video_export_opacity_aria = /** @type {(inputs: Video_Export_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacidad del texto`)
};

const zh_cn2_video_export_opacity_aria = /** @type {(inputs: Video_Export_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本不透明度`)
};

const ja_video_export_opacity_aria = /** @type {(inputs: Video_Export_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストの不透明度`)
};

const hi_video_export_opacity_aria = /** @type {(inputs: Video_Export_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ अपारदर्शिता`)
};

const pt_pt2_video_export_opacity_aria = /** @type {(inputs: Video_Export_Opacity_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacidade do texto`)
};

/**
* | output |
* | --- |
* | "Text Opacity" |
*
* @param {Video_Export_Opacity_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_opacity_aria = /** @type {((inputs?: Video_Export_Opacity_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Opacity_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_opacity_aria(inputs)
	if (locale === "de") return de_video_export_opacity_aria(inputs)
	if (locale === "it") return it_video_export_opacity_aria(inputs)
	if (locale === "ru") return ru_video_export_opacity_aria(inputs)
	if (locale === "es") return es_video_export_opacity_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_opacity_aria(inputs)
	if (locale === "ja") return ja_video_export_opacity_aria(inputs)
	if (locale === "hi") return hi_video_export_opacity_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_opacity_aria(inputs)
	return en_video_export_opacity_aria(inputs)
});